import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funkprotokoll-report-data';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollReportDataEffects {

    FunkprotokollReportData$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKPROTOKOLL_REPORT_DATA),
        mergeMap((x: ac.GetFunkprotokollReportDataAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunkprotokollReportData(x.veranstaltung_id, x.fall_id).pipe(
                map((result: any) => {
                    return new ac.GetFunkprotokollReportDataErfolgreichAction(result, x.veranstaltung_id, x.fall_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunkprotokollReportDataFehlerAction(error, x.veranstaltung_id, x.fall_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollQueryService);
        }
        return this.service;
    }
}
